var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"json-type-com"},[(_vm.showData.error)?_c('div',{staticClass:"error"},[_vm._v("ERROR：无法解析的信息。")]):(_vm.showData.type == 'table')?_c('v-table',{attrs:{"isPage":_vm.isPage,"json":_vm.showData}}):_c('div',{staticClass:"error"},[_vm._v("ERROR：不支持的消息类型。")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ee8817a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/jsonType/index.vue
// module id = MUd3
// module chunks = 30